import { createComponentInstance, findComponent } from '../../../assets/utils/components'
import api_catcher from '../../../api/api_catcher.js'

export const findWidget = function (root) {
    return findComponent(root, 'vx-widget')
}

export const createWidgetInstance = function (importedComponent) {
    var root = createComponentInstance(importedComponent, true, {
        config: {},
        widget: {}
    })
    var widget = findWidget(root)
    return widget
}

export default {
    createWidgetInstance,
    findWidget
}
